import { isEmpty } from 'lodash'
import React, { Suspense } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { getLoggedInUserInfo } from 'utils'
import { userRoleEnums } from 'enums/userRole'

const ProtectedRoute = ({ routerAnimation, Component, roles, modules, permission, ...rest }) => {
  const userRoles = getLoggedInUserInfo()?.userRoles || {}
  const subscribedModules = getLoggedInUserInfo()?.subscribedModules || []
  const userRole = getLoggedInUserInfo()?.userRole
  const hasSubscriptionScope = Boolean(getLoggedInUserInfo()?.hasSubscriptionScope)
  const allowSubscriptionModules = hasSubscriptionScope && userRole === userRoleEnums?.ADMIN
  const hasPermissionMap =
    !isEmpty(userRoles) || (allowSubscriptionModules && subscribedModules.length > 0)

  if (userRoles !== undefined) {
    userRoles['404'] = ['all']
  }

  const hasPermissionAccess = (modulePermissions = [], requiredPermission) =>
    modulePermissions.includes(requiredPermission) || modulePermissions.includes('all')

  const hasModuleAccess = (moduleKey) =>
    Object.prototype.hasOwnProperty.call(userRoles, moduleKey) ||
    (allowSubscriptionModules && subscribedModules.includes(moduleKey))

  let isAuthenticate = !hasSubscriptionScope && userRole === userRoleEnums?.ADMIN
  if (hasPermissionMap) {
    for (let i = 0; i < modules?.length; i += 1) {
      const module = modules[i]
      if (
        module === 'profile' ||
        module === 'logIn' ||
        module === 'candidate_form' ||
        (module === 'employee_self_service' &&
          (userRole === userRoleEnums?.EMPLOYEE || userRole === userRoleEnums?.USER))
      ) {
        isAuthenticate = true
        break
      }
      if (permission) {
        if (
          (Object.prototype.hasOwnProperty.call(userRoles, module) &&
            hasPermissionAccess(userRoles[module], permission)) ||
          (allowSubscriptionModules && subscribedModules.includes(module))
        ) {
          isAuthenticate = true
          break
        } else {
          isAuthenticate = false
          break
        }
      }
      if (hasModuleAccess(module)) {
        isAuthenticate = true
        break
      }
    }
  }
  if (rest.path.includes('reset-password')) {
    isAuthenticate = true
  }
  if (rest.path.includes('temporary-password-reset')) {
    isAuthenticate = true
  }
  if (rest.path.includes('candidate-form')) {
    isAuthenticate = true
  }
  if (rest.path.includes('candidate-bank-details-form')) {
    isAuthenticate = true
  }
  return (
    <Route
      {...rest}
      render={() => {
        if (!hasPermissionMap && !hasSubscriptionScope) {
          return (
            <div className={routerAnimation}>
              <Suspense fallback={null}>
                <Component />
              </Suspense>
            </div>
          )
        }
        if (!isAuthenticate) {
          return <Redirect to="/auth/404" />
        }

        return (
          <div className={routerAnimation}>
            <Suspense fallback={null}>
              <Component />
            </Suspense>
          </div>
        )
      }}
    />
  )
}
export default ProtectedRoute
